import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';


@Component({
  selector: 'app-edit-company-tabs',
  templateUrl: './edit-company-tabs.component.html',
  styleUrls: ['./edit-company-tabs.component.scss']
})
export class EditCompanyTabsComponent implements OnInit {

  // params
  id: number | string;

  // base route for tab routes
  baseRoute: string = '/configuration/companies';

  constructor(
    private _route: ActivatedRoute,
    private _authSvc: AuthService
  ) { }

  canViewTransactionalEmails = this._authSvc.hasClaim('TransactionalEmails', 'View');
  canViewPodium: boolean = this._authSvc.hasClaim('PodiumIntegration', 'View');

  ngOnInit(): void {

    this._route.params.subscribe((params: any) => {
      this.id = params.id;
      this.baseRoute += `/${params.id}`
    });

  }

}
